import { _ as _extends } from "../extends-e61fd370.js";
import { _ as _objectWithoutProperties } from "../objectWithoutProperties-72d23964.js";
import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
export { default as Cards } from "./cards.js";
var _excluded = ["children", "border"];
var DEFAULT = "bg-white border rounded p-4";

function Card(_ref) {
  var children = _ref.children,
      border = _ref.border,
      props = _objectWithoutProperties(_ref, _excluded);

  var className = cx(props.className, DEFAULT, {
    "border-gray-200": border,
    "border-white": !border
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
    className: className
  }), children);
}

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  border: PropTypes.bool,
  className: PropTypes.string
};
export { Card as default };